import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=8d5e5ac0&scoped=true&lang=pug"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
import style0 from "./Services.vue?vue&type=style&index=0&id=8d5e5ac0&prod&lang=scss&scoped=true"
import style1 from "./Services.vue?vue&type=style&index=1&id=8d5e5ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5e5ac0",
  null
  
)

export default component.exports